module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-9-94c34795.png";